export default __webpack_public_path__ + "static/media/Grüne.23dd2fca.mp4";